// You can write your custom Javascript here
$(document).ready(function () {

	// Sort By
	$('#sortByFilters').click(function (e) {
		e.preventDefault();
		$(this).parent().find('#sortByList').toggleClass('tw-hidden');
		return false;
	});

	// Filter
	$('.collectionFilters #filterTitle').click(function (e) {
		$(this).find('#filterExtraItems').toggleClass(
			'md:tw-hidden'
		);
		$(this)
			.parents('#filterItem')
			.find('#filterExtraItems')
			.toggleClass('md:tw-hidden');
	});

	if (window.innerWidth < 767) {
		$('#mobileFilterBtn').click(function (e) {
			$('#mobileFilterOverlay').removeClass('tw-opacity-0 -tw-z-[999]');
			$('#mobileFilterOverlay').addClass('tw-opacity-1 tw-z-[999]');
			$('#mobileFiltersPop').removeClass('-tw-left-full');
			$('#mobileFiltersPop').addClass('tw-left-0');
		});

		$('#closeMobFilPop').click(function (e) {
			$('#mobileFilterOverlay').removeClass('tw-opacity-1 tw-z-[999]');
			$('#mobileFilterOverlay').addClass('tw-opacity-0 -tw-z-[999]');
			$('#mobileFiltersPop').removeClass('tw-left-0');
			$('#mobileFiltersPop').addClass('-tw-left-full');
		});
	}

	// New popOut search
	$('input#popOutSearch').keyup(function (event) {
		$('#popUpSearchResults').empty();
		var searchValue = this.value;

		if (searchValue.length >= 3) {
			$(this).attr('triggered', true);
			console.log('runn the search');

			$.ajax({
				url:
					document.location.origin +
					'/search?view=ajax&q=' +
					searchValue,
				type: 'GET',
				success: function (res) {
					$('#popUpSearchResults').append(res);
					$('#viewAllLink').attr(
						'href',
						document.location.origin + '/search?q=' + searchValue
					);
				},
				error: function (error) {
					console.log('there was an error');
					console.log(error);
				},
			});
		} else {
			$(this).attr('triggered', false);
		}
	});

	// Navigation
	$('.nav-trigger.header__nav-trigger').click(function (e) {
		e.preventDefault();

		$('#mainNav').removeClass('-tw-left-80', 'sm:-tw-left-96');
		$('#mainNav').addClass('tw-left-0');

		return false;
	});

	$('#mainNav .menu__close').click(function (e) {
		e.preventDefault();

		$('.nav-trigger.header__nav-trigger').removeClass('is-active');
		$('#mainNav').removeClass('tw-left-0');
		$('#mainNav').addClass('-tw-left-80', 'sm:-tw-left-96');

		return false;
	});

	$('#mainNav .menu__item').hover(function (e) {
		var overlay = $('.nav-overlay');
		if ($(this).hasClass('menu__item--has-dropdown')) {
			$(overlay).removeClass('tw-hidden');
		} else {
			$(overlay).addClass('tw-hidden');
		}
	});

	$('.nav-overlay').hover(function (e) {
		$(this).addClass('tw-hidden');
	});

	// Home page products
	if ($('#homeProducts').length > 0) {
		$('#homeProducts').slick({
			arrows: true,
			dots: false,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 767,
					settings: 'unslick',
				},
			],
		});
	}

	// Header Banner Sliders
	if ($('#homeFourColumns').length > 0) {
		$('#homeFourColumns').slick({
			arrows: false,
			dots: false,
			slidesToShow: 4,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: true,
						dots: true,
						slidesToShow: 1,
						autoplay: true,
						autoplaySpeed: 4000,
						fade: true,
					},
				},
			],
		});
	}

	// New product slider
	if ($('.product-slider-for').length > 0) {
		$('.product-slider-for').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.product-slider-nav',
		});
		$('.product-slider-nav').slick({
			slidesToShow: 3,
			slidesToScroll: 1,
			asNavFor: '.product-slider-for',
			dots: false,
			centerMode: true,
			focusOnSelect: true,
			vertical: true,
			arrows: false,
			centerPadding: 0,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						vertical: false,
					},
				},
			],
		});
	}

	// Plus and Minus Buttons for quantity on product pages
	// This button will increment the value
	$('.qtyplus').click(function (e) {
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		fieldName = $(this).attr('field');
		// Get its current value
		var currentVal = parseInt($('input[name=' + fieldName + ']').val());
		// If is not undefined
		if (!isNaN(currentVal)) {
			// Increment
			$('input[name=' + fieldName + ']').val(currentVal + 1);
			$('input[name=' + fieldName + ']').change();
			$(this).prev().prev().removeClass('disabled');
			$(this).prev().prev().prop('disabled', false);
		} else {
			// Otherwise put a 0 there
			$('input[name=' + fieldName + ']').val(0);
			$('input[name=' + fieldName + ']').change();
		}
	});
	// This button will decrement the value till 0
	$('.qtyminus').click(function (e) {
		// Stop acting like a button
		e.preventDefault();
		// Get the field name
		fieldName = $(this).attr('field');
		// Get its current value
		var currentVal = parseInt($('input[name=' + fieldName + ']').val());
		// If it isn't undefined or its greater than 0
		if (!isNaN(currentVal) && currentVal > 2) {
			// Decrement one
			$('input[name=' + fieldName + ']').val(currentVal - 1);
			$('input[name=' + fieldName + ']').change();
			$(this).removeClass('disabled');
			$(this).prop('disabled', false);
		} else {
			// Otherwise put a 0 there
			$(this).addClass('disabled');
			$(this).prop('disabled', true);
			$('input[name=' + fieldName + ']').val(1);
			$('input[name=' + fieldName + ']').change();
		}
	});

	// Header Banner Sliders
	if ($('.headerBanner').length > 0) {
		$('.headerBanner').slick({
			arrows: false,
			dots: false,
			autoplay: true,
			autoplaySpeed: 4000,
			fade: true,
		});
	}

	$('button[data-toggle-modal]').click(toggleModal);

	checkSwatches();

	$(window).on('resize', function() {
		checkSwatches();
	});

	$(document).on('click', '.product-item .swatches .moreColours .open', function() {

		$product = $(this).parents('.product-item');
		$swatches = $($product).find('.swatches__items .swatches__item');
		$($swatches).each(function() {
			$(this).removeClass('tw-hidden');
		});
			
		$(this).find('.moreColours').removeClass('closed');
		$(this).find('.moreColours').addClass('opened');
		$(this).hide();
		$(this).parent().find('.close').show();

	});
	
	$(document).on('click', '.product-item .swatches .moreColours .close', function() {

		$product = $(this).parents('.product-item');
		
		checkSwatches($product);

		$($product).find('.moreColours').addClass('closed');
		$($product).find('.moreColours').removeClass('opened');
		$(this).hide();
		$(this).parent().find('.open').show();

	});

	///

	$('.filter-form').on('submit', function(event) {
		// Prevent the default form submission
		event.preventDefault();

		// Get the current URL
		var currentUrl = new URL(window.location.href);
	
		// Get the search query if it exists
		var searchQuery = currentUrl.searchParams.get('q');
	
		// Get all form data as a query string
		var formData = $(this).serialize();
	
		// If there's a search query, append it to the form data
		if (searchQuery) {
		  formData += '&q=' + encodeURIComponent(searchQuery);
		}

		// Construct the new URL with form data (filters) and search query
		var newUrl = currentUrl.pathname + '?' + formData;
	
		// Replace the current history state with the new URL
		history.replaceState(null, '', newUrl);
	
		// Optionally, trigger a page reload or AJAX request to update the content
		window.location.href = newUrl;
	});
	  

	///

	// Function to remove <span> tags and replace <p> tags with <br> tags
	function cleanText( element ) {
		
		let newContent = '';

		$(element).each(function() {

 			$(this).find('p').each(function() {
				let spanContent = $(this).html();
				newContent += spanContent + '<br><br>';
			});

		});

		return newContent;
	}

	function countWords(text) {

		// Remove <span> tags and replace <br> tags with spaces
		var cleanedText = text.replace(/<span[^>]*>|<\/span>/g, '').replace(/<br\s*\/?>/gi, ' ');

		// Split the cleaned text by spaces to count words
		const words = cleanedText.trim().split(/\s+/);

		return words;
	}

	// Reworked read more on collection descriptions
	if ($('.collection__entry-inner').length > 0) {
		const textElement = $(this).find('.text');
		const readMoreBtn = $(this).find('.read-more-btn');
		
		const cleanedElement = cleanText(textElement);

		const fullText = cleanedElement;
		const words = countWords(fullText);
		// fullText.split(' ').map(word => word.replace(/<br>/g, ' ')); // Handle <br> tags
		
		if (words.length > 40) {
			const shortText = words.slice(0, 40).join(' ') + '...';
			const formattedShortText = shortText.replace(/ /g, ' ').replace(/\.\.\.$/, '...<br>');

			$(textElement).html(formattedShortText);
			
			$(readMoreBtn).show();
			
			$(readMoreBtn).click(function () {
				if( textElement.hasClass('opened') ) {
					$(this).addClass('tw-mt-5');
					$(textElement).html(formattedShortText);
					$(readMoreBtn).text('Read More');
					$(textElement).removeClass('opened');
				} else {
					$(this).removeClass('tw-mt-5');
					$(textElement).html(fullText);
					$(readMoreBtn).text('Read Less');
					$(textElement).addClass('opened');
				}
			});
		} else {			
			$(readMoreBtn).hide();
		}
	}

});

// Collections swatches - make it on one line
function hideSwatches(product, perLine) {
	$(product).each(function() {

		$swatches = $(this).find('.swatches__items .swatches__item');
		$numberOfSwatches = $($swatches).length;
		$i = 0;
		$line = perLine - 1;

		if( $numberOfSwatches > perLine ) {

			$(this).find('.swatches .moreColours').removeClass('tw-hidden');

			$($swatches).each(function() {

				$i = $i + 1;

				if( $i > $line ) {
					$(this).addClass('tw-hidden');
				}

			});

			i = 0;

		}

	});
}

function checkSwatches() {
	if( $(window).width() < 769 ) {
		hideSwatches($('.product-item'), 5);
	} else if( $(window).width() < 1140 && $(window).width() > 768 ) {
		hideSwatches($('.product-item'), 6);
	} else {
		hideSwatches($('.product-item'), 8);
	}
}

// ====================================== //
// Quick Buy Modal Functionality
// ====================================== //

async function getProductData(productHandle) {
	// If no product ID, exit
	if (!productHandle) {
		return;
	}

	let data = {};

	const JSONdata = await $.getJSON(
		window.Shopify.routes.root + 'products/' + productHandle + '.js',
		function (data) {
			return data;
		}
	);

	data = {
		...JSONdata,
	};

	const HTMLdata = await $.get(
		window.Shopify.routes.root + 'products/' + productHandle,
		function (data) {
			return data;
		}
	);
	const parsedHTML = $.parseHTML(HTMLdata);
	const $quickBuyDataEle = $('[data-quick-buy]', parsedHTML);

	if (!$quickBuyDataEle) {
		return data;
	}

	const quickBuyData = JSON.parse($quickBuyDataEle.html());

	data = {
		...data,
		...quickBuyData,
	};

	const $compareDataEle = $('[data-compare]', parsedHTML);

	if (!$compareDataEle) {
		return data;
	}

	const compareData = JSON.parse($compareDataEle.html());

	data = {
		...data,
		...quickBuyData,
		...compareData,
	};

	return data;
}

async function toggleModal({ modal, productHandle }) {
	// If no modal target or product ID, exit
	if (modal === '' || productHandle === '') {
		return;
	}

	const $targetModal = $('div[data-modal="' + modal + '"]');

	resetQuickBuyModal($targetModal);

	// If no modal found, exit
	if ($targetModal.length === 0) {
		return;
	}

	// Toggle modal visibility & animate
	$targetModal.removeClass('tw-hidden');
	setTimeout(function () {
		$targetModal.addClass('modal-visible');
	}, 50);

	// Prevent body from scrolling when modal is open
	$('body').addClass('tw-overflow-hidden');

	const $closeButton = $(
		'button[data-toggle-modal="' + modal + '"]',
		$targetModal
	);
	$closeButton.click(function () {
		closeModal($targetModal);
	});

	const productOptions = await getProductData(productHandle);

	prepQuickBuyForm($targetModal, productOptions);

	populateQuickBuyModal($targetModal, productOptions);
}

function closeModal($modal) {

	$modal.removeClass('modal-visible');

	setTimeout(function () {
		$modal.addClass('tw-hidden');

		// Reset body scroll
		$('body').removeClass('tw-overflow-hidden');
	}, 310);
}

function prepQuickBuyForm($modal, { id, variants }) {
	// If no product ID, exit
	if (!id) {
		return;
	}

	// If anything other than one variant exists, exit
	if (variants.length !== 1) {
		return;
	}

	const variantID = variants[0].id;

	const $form = $('form[data-modal-form]', $modal);

	// If no form, exit
	if (!$form) {
		return;
	}

	// Set form ID attribute
	$form.attr('id', 'product_form_' + id);

	const $variantInput = $('input[name="id"]', $form);

	// If no variant input, exit
	if (!$variantInput) {
		return;
	}

	// Set variant input value
	$variantInput.val(variantID);

	const $submitButtons = $('button[type="submit"]', $form);

	$submitButtons.each(function () {
		const $button = $(this);

		$button.on('click', function () {
			handleQuickBuyFormSubmission($form, $modal, $button);
		});
	});
}

async function handleQuickBuyFormSubmission($form, $modal, $submitButton) {
	// If no form, exit
	if (!$form) {
		return;
	}

	// Prevent native form submission
	$form.submit((e) => e.preventDefault());

	const purchaseJourney = $submitButton.val();
	const transactionItems = getTransactionItems($form);
	const originalSubmitButtonText = $submitButton.text();

	// Set submit button text to "Working..."
	$submitButton.text('Working...');

	// If purchase journey set to "checkout", redirect to checkout
	if (purchaseJourney === 'checkout') {
		try {
			await handleAddToCart(transactionItems);

			return (window.location.href = '/checkout');
		} catch (error) {
			console.error(error);

			alert(
				'There was an error adding this item to your cart. Please try again.'
			);
		}
	}

	// Hide modal on cart open
	window.addEventListener('cart:open', function () {
		$submitButton.text(originalSubmitButtonText);

		$('button[data-toggle-modal]', $modal).click();
	});

	// Add items to ajax cart & open cart drawer
	Cart.add(transactionItems);
}

function handleAddToCart(items) {
	return new Promise((resolve, reject) => {
		$.ajax({
			type: 'POST',
			url: '/cart/add.js',
			data: {
				items,
			},
			dataType: 'json',
			success: function (cart) {
				resolve(cart);
			},
			error: function (XMLHttpRequest, textStatus) {
				reject(textStatus);
			},
		});
	});
}

function getTransactionItems($form) {
	const id = $('input[name="id"]', $form).val();
	const quantity = $('input[name="quantity"]', $form).val();

	// If no product ID, exit
	if (!id) {
		return;
	}

	// If no quantity, exit
	if (!quantity) {
		return;
	}

	return [
		{
			id,
			quantity,
		},
	];
}

function populateQuickBuyModal(
	$modal,
	{ featured_image, title, price, url, sizes, colors }
) {
	const $productImagePlaceholder = $(
		'[data-placeholder="product-image"]',
		$modal
	);
	const $productImage = $('img[data-product-image]', $modal);
	const $productTitle = $('h2[data-product-title]', $modal);
	const $productPrice = $('span[data-product-price]', $modal);
	const $productLink = $('a[data-product-link]', $modal);

	// Product Image
	$productImagePlaceholder.addClass('tw-hidden');
	$productImage.attr('src', featured_image);

	// Product Title
	$('[data-placeholder]', $productTitle).addClass('tw-hidden');
	$('[data-content]', $productTitle).html(title);

	// Product Price
	$('[data-placeholder]', $productPrice).addClass('tw-hidden');
	$('[data-content]', $productPrice).html(
		'£'+Shopify.formatMoney(price, window.Shopify.current_money_format)
	);

	// Product Click Through
	$productLink.attr('href', url);

	// Product Size Options
	populateProductSizeOptions($modal, sizes);

	// Product Colour Options
	populateProductColorOptions({ modal: $modal, colors: colors, isEmpty: true });
}

function populateProductSizeOptions($modal, sizes) {
	// If no sizes, exit
	if (!sizes) {
		return;
	}

	console.log(sizes);

	const buttonTemplate = $('[data-template="size-button"]', $modal).html();

	// If no button template, exit
	if (!buttonTemplate) {
		return;
	}

	const $buttonContainer = $('[data-content="size-buttons"]', $modal);

	// If no button container, exit
	if (!$buttonContainer) {
		return;
	}

	// Clear out any existing buttons
	$('[data-placeholder="size-buttons"]', $modal).addClass('tw-hidden');
	$buttonContainer.empty();

	sizes.forEach(function ({ label, handle, activeClass }) {
		// Populate button html template string with data
		const buttonHtml = parseTemplate(buttonTemplate, {
			label,
			handle,
			activeClass,
		});

		// Append button to container
		$buttonContainer.append(buttonHtml);
	});
}

function populateProductColorOptions({ modal, colors, isEmpty }) {
	const $modal = modal;

	// If no colors, exit
	if (!colors) {
		return;
	}

	const buttonTemplate = $('[data-template="color"]', $modal).html();

	// If no button template, exit
	if (!buttonTemplate) {
		return;
	}

	const $buttonContainer = $('[data-content="colors"]', $modal);

	// If no button container, exit
	if (!$buttonContainer) {
		return;
	}

	// Clear out any existing buttons
	$('[data-placeholder="colors"]', $modal).addClass('tw-hidden');
	
	if (isEmpty) {
		$buttonContainer.empty();
	}

	colors.forEach(function ({ label, handle, activeClass }) {
		// Populate button html template string with data
		const buttonHtml = parseTemplate(buttonTemplate, {
			label,
			handle,
			activeClass,
		});

		// Append button to container
		$buttonContainer.append(buttonHtml);
	});
}

function parseTemplate(template, data) {
	return template.replaceAll(/\[\[(\w+)\]\]/g, function (match, key) {
		return data[key] || '';
	});
}

function resetQuickBuyModal($modal) {
	console.log('resetting');
	// remove tw-hidden from all placeholders
	$('[data-placeholder]', $modal).removeClass('tw-hidden');
	// img remove source
	$('img[data-product-image]', $modal).attr('src', '');
	// content elements need to be emptied
	$('[data-content]', $modal).html('');
}

async function toggleQuickBuyProduct(productHandle) {
	const modal = 'quickBuy';
	const $targetModal = $('div[data-modal="' + modal + '"]');

	const productOptions = await getProductData(productHandle);

	prepQuickBuyForm($targetModal, productOptions);

	populateQuickBuyModal($targetModal, productOptions);
}